import { Component, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { LookerAdminService } from 'src/app/services/looker-admin.service';

import { LookerViewComponent } from '../looker-view/looker-view.component';

@Component({
  selector: 'app-looker-summary',
  templateUrl: './looker-summary.component.html',
  styleUrls: ['./looker-summary.component.less']
})
export class LookerSummaryComponent {

  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private route: ActivatedRoute,
    private lookerAdminService: LookerAdminService
  ) {}
  public loadingStatus: boolean;
  public pageSize = 10;
  private routeSub: any;
  routeActivated = false;
  healthcareTopBarLoaded: Subscription;
  scroll: any;

  ngOnInit(): void {
    this.scroll = window.pageYOffset;
    const self = this;
  }
  // clean up to prevent memory leaks, by unsubscribing to subscribed events
  ngOnDestroy(): void {}
  // check if user has edit feature
  initialPageSetup(): void {}

  routeChanged(): void {
    this.routeActivated = true;
    if (this.authorizationService.HealthcareTopBar) {
      this.authorizationService.HealthcareTopBar.notifyActivity();
    }
  }

  sideNavDashboardItemsComplete($event) {
    this.lookerAdminService.sendMessage($event);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event): void {
    const prevScrollpos = window.pageYOffset;
    const currentScrollPos = window.pageYOffset;
    if (prevScrollpos <= 71) {
      document.getElementById('navbar').style.top = 71 - prevScrollpos + 'px';
    } else {
      document.getElementById('navbar').style.top = '0px';
    }
  }
}
